import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const openRecordLink = (recordLink: any, language: string) => {
  if (window.confirm(translate(language, "PAGES.MEETING.MANAGE_MEETING.INFORMATION.RECORD_LINK.ALERT_MESSAGE"))) {
    navigator.clipboard.writeText(recordLink.password);
    window.open(recordLink.share_url, "_blank");
  }
};

export const copyMeetingLink = (meeting_link: string, language: string, setShowCopyMeetingLinkToast: Function) => {
  navigator.clipboard
    .writeText(meeting_link)
    .then(() => setShowCopyMeetingLinkToast(true))
    .catch((err) =>
      console.error(translate(language, "PAGES.MEETING.MANAGE_MEETING.INFORMATION.MEETING_LINK.COPY_ERROR"), err)
    );
};

export const copyRecordLinkMessage = (recordLink: any, language: string, setShowCopyRecordToast: Function) => {
  navigator.clipboard
    .writeText(`Share URL : ${recordLink.share_url}\nPassword : ${recordLink.password}`)
    .then(() => setShowCopyRecordToast(true))
    .catch((err) =>
      console.error(translate(language, "PAGES.MEETING.MANAGE_MEETING.INFORMATION.RECORD_LINK.COPY_ERROR"), err)
    );
};

export const addUsersToAttendance = (
  meetingId: string,
  userIds: number[],
  language: string,
  successCallback?: Function,
  finalCallback?: Function
) => {
  ApiService.post(`meetings/${meetingId}/attendance/users`, { user_ids: userIds })
    .then(() => {
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.SUCCESS.ADD_USERS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error adding users to attendance:", error);
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.ERROR.ADD_USERS"));
    })
    .finally(() => {
      finalCallback?.();
    });
};

export const removeUsersFromAttendance = (
  meetingId: string,
  userIds: number[],
  language: string,
  successCallback?: Function,
  finalCallback?: Function
) => {
  ApiService.delete(`meetings/${meetingId}/attendance/users`, { user_ids: userIds })
    .then(() => {
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.SUCCESS.REMOVE_USERS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error removing users from attendance:", error);
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.ERROR.REMOVE_USERS"));
    })
    .finally(() => {
      finalCallback?.();
    });
};

export const addCohortsToAttendance = (
  meetingId: string,
  cohortIds: number[],
  language: string,
  successCallback?: Function,
  finalCallback?: Function
) => {
  ApiService.post(`meetings/${meetingId}/attendance/cohorts`, { cohort_ids: cohortIds })
    .then(() => {
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.SUCCESS.ADD_COHORTS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error adding cohorts to attendance:", error);
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.ERROR.ADD_COHORTS"));
    })
    .finally(() => {
      finalCallback?.();
    });
};

export const removeCohortsFromAttendance = (
  meetingId: string,
  cohortIds: number[],
  language: string,
  successCallback?: Function,
  finalCallback?: Function
) => {
  ApiService.delete(`meetings/${meetingId}/attendance/cohorts`, { cohort_ids: cohortIds })
    .then(() => {
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.SUCCESS.REMOVE_COHORTS"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error removing cohorts from attendance:", error);
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.ALERTS.ERROR.REMOVE_COHORTS"));
    })
    .finally(() => {
      finalCallback?.();
    });
};

export const getAnimators = (setAnimators: Function, setLoading: Function, language: string) => {
  setLoading((loading: any) => ({ ...loading, animators: true }));
  ApiService.get("meetings/resources?only_active_animators=true")
    .then((response) => {
      setAnimators(response.data.meeting_staff_and_programs.animators);
    })
    .catch((error) => {
      console.error("Failed to get animators:", error);
      alert(translate(language, "PAGES.MEETING.ERRORS.GET_ADMINS"));
    })
    .finally(() => setLoading((loading: any) => ({ ...loading, animators: false })));
};

export const sendAnimatorsInvitations = (
  meetingId: string,
  language: string,
  setLoading: Function,
  successCallback?: Function
) => {
  setLoading(true);
  ApiService.post(`meetings/${meetingId}/animators/ics`, {})
    .then((_) => successCallback?.())
    .catch((error) => {
      console.error("Error sending ICS to animators:", error);
      alert(translate(language, "PAGES.MEETING.MANAGE_MEETING.ALERTS.SEND_ICS_ANIMATORS_ERROR"));
    })
    .finally(() => setLoading(false));
};
